import {ContentBaseHeader} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/Mobile/Contents/ContentBase';
import {menuMappingKeys} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

export const MWEditorDrawerHeader = ({
  activeMenu,
  showMenu,
  onCloseEditorClick,
  onClickCloseTabHandler,
  isPhotoDrawer = false,
}) => {
  if (!showMenu) return null;

  if (activeMenu === 'text') {
    return (
      <div className="mobile-editor__header">
        <Typography
          variant="label2"
          className="card_editor--mobile__close_btn_container__title__text"
        >
          Text
        </Typography>
        <Button
          variant="unstyled-button"
          className="card_editor--mobile__close_btn"
          onClick={onCloseEditorClick}
          data-qa-id="mobile-close-btn"
        >
          <CloseLineIcon ratio={0.75} />
        </Button>
      </div>
    );
  }

  let title = '';
  let style = {};
  let resetDataQaId = '';
  let closeDataQaId = '';
  let closeFunction = onClickCloseTabHandler;

  switch (activeMenu) {
    case menuMappingKeys.FONT_STYLE:
      title = 'Font Style';
      style = menuMappingKeys.FONT_STYLE;
      resetDataQaId = 'step1-textstyle-reset';
      closeDataQaId = 'step1-textstyle-close';
      break;
    case menuMappingKeys.FONT_SIZE:
      title = 'Font Size';
      style = menuMappingKeys.FONT_SIZE;
      resetDataQaId = 'step1-textsize-reset';
      closeDataQaId = 'step1-textsize-close';
      break;
    case menuMappingKeys.TEXT_FORMAT:
      title = 'Text Format';
      style = menuMappingKeys.TEXT_FORMAT;
      resetDataQaId = 'step1-textformat-reset';
      closeDataQaId = 'step1-textformat-close';
      break;
    case menuMappingKeys.SPACING:
      title = 'Spacing';
      style = menuMappingKeys.SPACING;
      resetDataQaId = 'step1-textspacing-reset';
      closeDataQaId = 'step1-textspacing-close';
      break;
    case menuMappingKeys.COLOR:
      title = 'Color';
      style = menuMappingKeys.COLOR;
      resetDataQaId = 'step1-textcolor-reset';
      closeDataQaId = 'step1-textcolor-close';
      break;
    case isPhotoDrawer:
    case 'image':
    case menuMappingKeys.UYO:
      title = 'Photo Editor';
      style = menuMappingKeys.UYO;
      resetDataQaId = 'step1-imagexy-reset';
      closeDataQaId = 'step1-imagexy-close';
      closeFunction = onCloseEditorClick;
      break;
    default:
      closeFunction = onCloseEditorClick;
      break;
  }

  return (
    <ContentBaseHeader
      resetDataQaId={resetDataQaId}
      closeDataQaId={closeDataQaId}
      title={title}
      style={style}
      onCloseClick={closeFunction}
      hideResetButton={activeMenu === menuMappingKeys.UYO}
    />
  );
};
